import { SxProps, Theme } from '@mui/material';

export const stylesSecurityPolicyPaper: SxProps<Theme> = { p: 2 };
export const stylesSecurityPolicyCard: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  padding: 3,
  gap: 2,
};
export const stylesSecurityPolicyCardIcon: SxProps<Theme> = { fontSize: 40, color: 'primary.main' };
export const stylesSecurityPolicyCardContainer: SxProps<Theme> = { display: 'flex', flexDirection: 'column' };
export const stylesSecurityPolicyCardContent: SxProps<Theme> = { flex: '1 0 auto', '&,&:last-child': { p: 0 } };
